module.exports = __webpack_public_path__ + "img/eMove_price_background.f6bb1f5c.png";